import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-base"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-950">韩漫之家</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              最新高清免费韩国漫画大全，热门韩漫在线阅读平台。每日更新，畅享正版韩漫阅读体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-foreground-950 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">全部漫画</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-foreground-950 mb-4">热门分类</h4>
            <ul className="space-y-2">
              <li><Link to="/category/romance" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">恋爱漫画</Link></li>
              <li><Link to="/category/fantasy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">奇幻漫画</Link></li>
              <li><Link to="/category/action" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">动作漫画</Link></li>
              <li><Link to="/category/thriller" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">悬疑漫画</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-foreground-950 mb-4">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-xs"></i>
                </div>
                contact@hanmanzhijia.com
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-xs"></i>
                </div>
                400-888-6666
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-line text-xs"></i>
                </div>
                北京市朝阳区望京SOHO
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 韩漫之家. 本站所有漫画均来自互联网，仅供学习交流使用，请于下载后24小时内删除。
          </p>
          <div className="flex items-center gap-4">
            <a href="https://weibo.com" target="_blank" rel="nofollow" className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-weibo-line"></i>
              </div>
            </a>
            <a href="https://weixin.qq.com" target="_blank" rel="nofollow" className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-wechat-line"></i>
              </div>
            </a>
            <a href="https://bilibili.com" target="_blank" rel="nofollow" className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-bilibili-line"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}